"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSubNavHeading = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSubNavHeading = styled_components_1.default.h2.withConfig({ displayName: "StyledSubNavHeading", componentId: "sc-1ome74" }) `
  position: fixed;
  top: 62px;
  z-index: 100;
  margin-left: 19px;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  ${(props) => props.theme.responsiveFontsize.body.medium}

  ${(props) => (0, ui_1.mq)({
    display: [props.isSubNavOpen ? 'block' : 'none', 'block'],
})}
`;
